import { render, staticRenderFns } from "./CustomerImportPreviewEmail.vue?vue&type=template&id=82f2f9a8&scoped=true&"
import script from "./CustomerImportPreviewEmail.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportPreviewEmail.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerImportPreviewEmail.vue?vue&type=style&index=0&id=82f2f9a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f2f9a8",
  null
  
)

export default component.exports